module.exports = __webpack_public_path__ + "img/pro_two_1.421ca4a3.jpg";